import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { VehicleInsuranceDocument } from '@models';

export enum FileType {
  PDF = 'pdf',
  IMAGE = 'image',
}

@Component({
  selector: 'app-vehicle-insurance-document',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
  ],
  templateUrl: './vehicle-insurance-document.component.html',
  styleUrl: './vehicle-insurance-document.component.scss',
})
export class VehicleInsuranceDocumentComponent implements OnChanges {
  FileType = FileType;
  @Input() document!: VehicleInsuranceDocument;

  public fileType: FileType = FileType.IMAGE;

  public documentUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) {
    if (this.document) {
      this.fileType = this.getFileType(this.document.documentUrl);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['document']) {
      this.fileType = this.getFileType(this.document.documentUrl);
    }
  }

  private getFileType(documentUrl: string): FileType {
    this.documentUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(documentUrl);
    const fileExtension = documentUrl.split('.').pop();
    if (fileExtension === 'pdf') return FileType.PDF;
    return FileType.IMAGE;
  }

  public downloadDocument() {
    window.open(this.document.documentUrl, '_blank');
  }
}
